import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tooltip from './tooltip';

class InfoTooltip extends Component {
  static displayName = 'InfoTooltip';
  static propTypes = {
    children: PropTypes.element.isRequired,
    alignElement: PropTypes.func,
    hideOnClick: PropTypes.bool,
    className: PropTypes.string
  };
  static defaultProps = {
    direction: 'bottom'
  };
  show() {
    this.refs.tooltip.show();
  }

  hide() {
    this.refs.tooltip.hide();
  }

  render() {
    return (
      <Tooltip
        {...this.props}
        className={classNames('tooltip-info', this.props.className)}
        ref="tooltip"
        horizontalAlign="center"
        caret={true}
      >
        {this.props.children}
      </Tooltip>
    );
  }
}

export default InfoTooltip;
